/**
 * THE APP'S ONE COLUMN WIDTH (§ F115, 2026-08-21).
 *
 * Jake, reviewing the menus on video: *"notice that when I click ANY game
 * category the layout completely changes. I want a consistent width across
 * everything. Just use the width set by this main menu that lists Trivia,
 * Doodle Duel, Game Table, Mini-Games."*
 *
 * That main menu is the hub's four doors, and its column is what every other
 * front door now uses: `max-w-md` on a phone (i.e. "the width of the screen")
 * widening to `max-w-lg` once there is width to cap. It was already the hub's;
 * Doodle Duel was `max-w-[430px]` growing to `max-w-3xl`, mini-games was
 * `max-w-md` at every width ("a little too narrow if following the width set by
 * the main screen"), and Game Table had no cap at all.
 *
 * ONE STRING, imported — not a Tailwind class copied into six files, which is
 * exactly how the six of them drifted apart in the first place. The header
 * shares it too (`AppChrome`'s `column`), so the brand mark and the player icon
 * line up with the content under them at every width.
 *
 * IN-GAME surfaces are NOT this: a board sizes itself (§ F58) and the party
 * game screens size to their own content. This is about the front doors — the
 * screens Jake clicked through in the review.
 */
export const APP_COLUMN = "w-full max-w-md [@media(min-width:600px)]:max-w-lg";

/** The padding those columns sit in, so the header can mirror it exactly. */
export const APP_COLUMN_PAD = "px-3 [@media(min-height:700px)]:px-6";
